/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OfferRequestPassengerWithAge } from './OfferRequestPassengerWithAge';
import {
    instanceOfOfferRequestPassengerWithAge,
    OfferRequestPassengerWithAgeFromJSON,
    OfferRequestPassengerWithAgeFromJSONTyped,
    OfferRequestPassengerWithAgeToJSON,
} from './OfferRequestPassengerWithAge';
import type { OfferRequestPassengerWithFareType } from './OfferRequestPassengerWithFareType';
import {
    instanceOfOfferRequestPassengerWithFareType,
    OfferRequestPassengerWithFareTypeFromJSON,
    OfferRequestPassengerWithFareTypeFromJSONTyped,
    OfferRequestPassengerWithFareTypeToJSON,
} from './OfferRequestPassengerWithFareType';
import type { OfferRequestPassengerWithType } from './OfferRequestPassengerWithType';
import {
    instanceOfOfferRequestPassengerWithType,
    OfferRequestPassengerWithTypeFromJSON,
    OfferRequestPassengerWithTypeFromJSONTyped,
    OfferRequestPassengerWithTypeToJSON,
} from './OfferRequestPassengerWithType';

/**
 * @type OfferRequestPassengersInner
 * 
 * @export
 */
export type OfferRequestPassengersInner = OfferRequestPassengerWithAge | OfferRequestPassengerWithFareType | OfferRequestPassengerWithType;

export function OfferRequestPassengersInnerFromJSON(json: any): OfferRequestPassengersInner {
    return OfferRequestPassengersInnerFromJSONTyped(json, false);
}

export function OfferRequestPassengersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferRequestPassengersInner {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfOfferRequestPassengerWithAge(json)) {
        return OfferRequestPassengerWithAgeFromJSONTyped(json, true);
    }
    if (instanceOfOfferRequestPassengerWithFareType(json)) {
        return OfferRequestPassengerWithFareTypeFromJSONTyped(json, true);
    }
    if (instanceOfOfferRequestPassengerWithType(json)) {
        return OfferRequestPassengerWithTypeFromJSONTyped(json, true);
    }
    return {} as any;
}

export function OfferRequestPassengersInnerToJSON(json: any): any {
    return OfferRequestPassengersInnerToJSONTyped(json, false);
}

export function OfferRequestPassengersInnerToJSONTyped(value?: OfferRequestPassengersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfOfferRequestPassengerWithAge(value)) {
        return OfferRequestPassengerWithAgeToJSON(value as OfferRequestPassengerWithAge);
    }
    if (instanceOfOfferRequestPassengerWithFareType(value)) {
        return OfferRequestPassengerWithFareTypeToJSON(value as OfferRequestPassengerWithFareType);
    }
    if (instanceOfOfferRequestPassengerWithType(value)) {
        return OfferRequestPassengerWithTypeToJSON(value as OfferRequestPassengerWithType);
    }
    return {};
}

